export enum EMode {
  query = 'query',
  entity = 'entity',
  upsert = 'upsert',
  path = 'path',
}
